import { gql } from "@apollo/client";

export default gql`
  mutation ExchangeMergePublicToken(
    $publicToken: String!
    $endUserOriginId: String!
  ) {
    exchangeMergePublicToken(
      publicToken: $publicToken
      endUserOriginId: $endUserOriginId
    ) {
      success
      integration {
        id
        category
        integrationName
        createdAt
      }
      error
    }
  }
`;
